//
export default [
    {
        name: 'name',
        props: {
            label: 'Nombre',
        },
        flex: {
            sm6: true,
            lg6: true,
        },
        type: 'text-field',
    },
    {
        name: 'description',
        props: {
            label: 'Descripcion',
        },
        flex: {
            sm6: true,
            lg6: true,
        },
        type: 'text-field',
    },
]
